import { useLocation, useNavigate, redirect, useParams } from "react-router-dom";
import { Check } from "react-feather";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import TextField from "../../components/UI/TextField";
import { getDroneDetails } from "../../api/dronesAPI";
import { useAuthStore } from "../../store/authStore";
import { useQuery } from "@tanstack/react-query";
import { capitalize } from "../../helpers/commonFunction";
import ShowDetailsLabel from "../../components/UI/showDetailsLabel";
import moment from "moment";
import GenerateQRCode from "../../components/UI/QRCode/QRCode";
import useDroneStore from "../../store/droneStore";
import { QrCode } from "@carbon/icons-react";
import DroneImgViewModal from "./model/droneImgViewModel";

const DroneDetails = () => {
    const navigate = useNavigate();
    const { droneId } = useParams()
    const { token, setLoaderState } = useAuthStore((state) => state)
    const [droneDetails, setDroneDetails] = useState([])
    const { isLoading, data, error } = useQuery({
        queryFn: getDroneDetails,
        queryKey: ["getSingleDrones", token, droneId],
        refetchOnWindowFocus: false,
    });
    const { showDroneQrCode, setShowDroneQrCode, droneImgToView, setDroneImgToView } = useDroneStore((state) => state)
    const [imageData, setImageData] = useState('');
    useEffect(() => {
        if (isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [isLoading])

    useEffect(() => {
        setDroneDetails(data?.data?.data)
        if (data?.data?.data) {
            // console.log(data?.data?.data?.img)
            setImageData(data?.data?.data?.img);
        }
    }, [data])
    return (
        <>
            {droneImgToView != '' && <DroneImgViewModal imgLink={droneImgToView} />}
            <div className="p-4">
                <ToastContainer />
                <div className="flex justify-between items-center">
                    <h1 className="text-4xl w-full h-full">Drone Details</h1>
                    <div className="flex space-x-3 items-center">
                        <QrCode
                            size={32}
                            className="cursor-pointer"
                            onClick={() => setShowDroneQrCode(true)}
                        />
                        {/* <button
                        className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                    >
                        Generate QR */}
                        {/* </button> */}
                        <button
                            onClick={() => navigate("/dashboard/")}
                            className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                        >
                            View Drones
                        </button>
                    </div>
                </div>
                <br />
                <hr />
                {
                    showDroneQrCode && <GenerateQRCode name={droneDetails?.droneName} data={{
                        identifier: droneDetails?.droneId,
                        droneName: droneDetails?.droneName,
                        droneCategory: droneDetails?.droneCategory,
                        droneUin: droneDetails?.uin
                    }} />
                }
                {
                    !isLoading &&
                    <form
                        // onSubmit={handleSubmit(submitDrone)}
                        className="grid grid-cols-2 gap-2 mt-10 leading-10"
                    >
                        <ShowDetailsLabel
                            label="Drone Name"
                            value={droneDetails?.droneName && capitalize(droneDetails?.droneName) || ""}
                        />
                        <ShowDetailsLabel
                            label="UIN"
                            value={droneDetails?.uin || ""}
                        />
                        <ShowDetailsLabel
                            label="Purchase Date"
                            value={droneDetails?.purchaseDate && moment(droneDetails?.purchaseDate).format('DD/MM/YYYY') || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone Category"
                            value={droneDetails?.droneCategory || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone Height (in meter)"
                            value={droneDetails?.height || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone Width (in meter)"
                            value={droneDetails?.width || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone Length (in meter)"
                            value={droneDetails?.length || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone Weight (in kgs)"
                            value={droneDetails?.totalWeight || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone MaxSpeed (in m/s)"
                            value={droneDetails?.maxSpeed || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone Crusing Speed (in m/s)"
                            value={droneDetails?.crusingSpeed || ""}
                        />
                        <ShowDetailsLabel
                            label="Drone Endurance (in minutes)"
                            value={droneDetails?.endurance || ""}
                        />
                        {droneDetails?.rejectionReason ? <ShowDetailsLabel
                            label="Rejection Reason"
                            value={droneDetails?.rejectionReason || ""}
                        /> : ""}
                    </form>
                }
                <div className="grid grid-cols-2">
                    {
                        imageData.length > 0 && imageData.map((img, index) => {
                            return (
                                <>
                                    <div className="mt-10" key={index}>
                                        <img src={img} key={index} onClick={() => { setDroneImgToView(img) }} className="h-40" alt="" />
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
            </div >
        </>
    )
}

export default DroneDetails;